import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Output } from '@angular/core';
import { ToastService } from '@app/services/toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-details-page-header',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './details-page-header.component.html',
  styleUrl: './details-page-header.component.scss',
})
export class DetailsPageHeaderComponent {
  public title = input.required<string>();
  public subtitle = input<string>('');
  public id = input<string>();
  public loading = input<boolean>(false);

  @Output() back = new EventEmitter<void>();

  constructor(
    private toast: ToastService,
    private translateService: TranslateService
  ) {}

  onCopyId(event: MouseEvent): void {
    event.stopPropagation();
    const id = this.id();
    if (id) navigator.clipboard.writeText(id);
    this.toast.info(
      this.translateService.instant('admin.toasts.idCopiedToClipboard')
    );
  }

  onBack(): void {
    this.back.emit();
  }
}
